import { createSelector, createSlice } from '@reduxjs/toolkit';

const appSettingsSlice = createSlice({
    initialState: {
        settings: [],
        isLoading: false,
        isUpdating: false,
    },
    name: 'appSettings',
    reducers: {
        fetchSettings: state => {
            state.settings = [];
            state.isLoading = true;
        },
        settingsFetched: (state, { payload }) => {
            const { results } = payload;
            state.settings = results[0];
            state.isLoading = false;
        },
        settingsFetchedFailed: state => {
            state.isLoading = false;
        },

        // Update settings
        updateSetting: state => {
            state.isUpdating = true;
        },
        settingUpdated: (state, { payload }) => {
            state.settings = { ...state.settings, ...payload };
            state.isUpdating = false;
        },
        settingUpdateFailed: state => {
            state.isUpdating = false;
        },

        // Message of the day
        updateMessageOfDay: state => {
            state.isUpdating = true;
        },
        messageOfDayUpdated: (state, { payload }) => {
            state.settings = { ...state.settings, ...payload };
            state.isUpdating = false;
        },
        messageOfDayUpdateFailed: state => {
            state.isUpdating = false;
        },

        // Toggle onboarding
        toggleOnboarding: state => {
            state.isUpdating = true;
        },
        onboardingToggled: (state, { payload }) => {
            state.settings = { ...state.settings, ...payload };
            state.isUpdating = false;
        },
        onboardingToggleFailed: state => {
            state.isUpdating = false;
        },
    },
});

// selectors
const getSelf = state => state.appSettings;

export const getSettings = createSelector(getSelf, state => {
    return state.settings;
});

export const isLoading = createSelector(getSelf, state => state.isLoading);

export const getIsUpdating = createSelector(getSelf, state => state.isUpdating);

export const {
    fetchSettings,
    settingsFetched,
    settingsFetchedFailed,
    updateSetting,
    settingUpdated,
    settingUpdateFailed,
    updateMessageOfDay,
    messageOfDayUpdated,
    messageOfDayUpdateFailed,
    toggleOnboarding,
    onboardingToggled,
    onboardingToggleFailed,
} = appSettingsSlice.actions;
export default appSettingsSlice.reducer;
